import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { immunizationsActions } from '../../../../../redux/immunizations'
import { recommendationsActions } from '../../../../../redux/recommendations'
import { connect } from 'react-redux'
import Pathology from '../../../../../models/Pathology/Pathology'
import Immunization from '../../../../../models/Immunization/Immunization'
import ImmunizationRecommendation from '../../../../../models/ImmunizationRecommendion/ImmunizationRecommendation'
import PathologiesGrid from './PathologiesGrid'
import { currentSelectionActions } from '../../../../../redux/currentSelection'
import withPolyglot from '../../../../common/withPolyglot'

class PathologiesGridContainer extends React.Component {
  getPathologies (entries = []) {
    const pathologies = []
    entries.forEach(entry => {
      pathologies.push(new Pathology(entry.pathology.id, entry.pathology.name, entry.pathology.displayKey, entry.entries))
    })
    return pathologies
  }

  addImmunizations (pathologies, immunizations = []) {
    immunizations.forEach(entry => {
      entry.protoInfo.forEach(info => {
        const {id, date, medicineCode, professional, observations, protoInfo: protocolInfo, type, adverseReactionId} = entry
        pathologies.find(p => p.id === info.pathology.id).addImmunization(new Immunization(id, date, medicineCode, professional, observations, protocolInfo, type, adverseReactionId))
      })
    })
  }

  isRecommendationFulfilled (recommendation, immunizations) {
    let fulfilled = false
    for (let immuno of immunizations) {
      const entry = immuno.protocolInfo.find(info => info.pathology.id === recommendation.pathologyId)
      if (immuno.type !== 'immunoglobulin') {
        fulfilled = entry.pathology.id === recommendation.pathologyId && entry.seqNumber === recommendation.doseNumber
      }
      if (fulfilled) {
        break
      }
    }
    return fulfilled
  }

  addRecommendations (pathologies, recommendations = []) {
    recommendations.forEach(recom => {
      const pathology = pathologies.find(p => p.id === recom.pathologyId)
      if (pathology && !this.isRecommendationFulfilled(recom, pathology.immunizations)) {
        const {id, date, vaccineCode, pathologyId, doseNumber, status, dateCriterion} = recom
        pathology.addRecommendation(new ImmunizationRecommendation(id, date, vaccineCode, pathologyId, doseNumber, status, dateCriterion))
      }
    })
  }

  isPlannedShotFulfilled (pathologyId, shot, immunizations) {
    let fulfilled = false
    for (let immuno of immunizations) {
      const entry = immuno.protocolInfo.find(info => info.pathology.id === pathologyId)
      fulfilled = entry.pathology.id === pathologyId && entry.seqNumber === shot.sequenceNumber
      if (fulfilled) {
        break
      }
    }
    return fulfilled
  }
  isPlannedShotRecommended (pathologyId, shot, recommendations) {
    let fulfilled = false
    for (let recom of recommendations) {
      fulfilled = shot.sequenceNumber === recom.doseNumber
      if (fulfilled) {
        break
      }
    }
    return fulfilled
  }
  addPlannedShots (pathologies) {
    pathologies.forEach(pathology => {
      pathology.entries.forEach(entry => {
        if (!this.isPlannedShotFulfilled(pathology.id, entry, pathology.immunizations) &&
          !this.isPlannedShotRecommended(pathology.id, entry, pathology.recommendations)) {
          const {sequenceNumber, val, unit} = entry
          pathology.addPlannedShot({sequenceNumber, val, unit})
        }
      })
    })
  }
  render () {
    const {
      immunizations,
      recommendations,
      protocolEntries,
      translate,
      editMode
    } = this.props
    const pathologies = this.getPathologies(protocolEntries)
    if (pathologies.length > 0) {
      this.addImmunizations(pathologies, immunizations)
      this.addRecommendations(pathologies, recommendations)
      this.addPlannedShots(pathologies)
    }
    if (pathologies) {
      return <div>
        <PathologiesGrid
          editMode={editMode}
          patientBirthDate={this.props.patientBirthDate}
          selectedPathology={this.props.currentSelection.pathology}
          removeSelectedPathology={this.props.removeSelectedPathology}
          selectPathology={this.props.selectPathology}
          pathologies={pathologies.filter(p => p.hasElements())} />
      </div>
    } else {
      return <div>{translate('loadingPathologies', true, 'PathologiesGrid')}</div>
    }
  }
}

PathologiesGridContainer.propTypes = {
  editMode: PropTypes.bool
}

PathologiesGridContainer.defaultProps = {
  editMode: false
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({...immunizationsActions, ...recommendationsActions, ...currentSelectionActions}, dispatch)
}

function mapStateToProps ({immunizations, recommendations, patient, plan, currentSelection}) {
  return {
    currentSelection,
    protocolEntries: plan.protocolEntries,
    immunizations: immunizations,
    recommendations: recommendations,
    patientBirthDate: patient.data.birthDate
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withPolyglot(PathologiesGridContainer, 'pathologiesGrid'))
